import i18n from "../translations/i18n";

const pushHistory = (query) => {
    const urlClass = new URL(document.location);

    if (query !== "" && query !== null) {
        urlClass.searchParams.set("query", query);
    } else {
        urlClass.searchParams.delete("query");
    }

    const urlWithoutQuery = urlClass.toString();
    const urlWithQuery = urlClass.toString();

    if (history.pushState) {
        window.history.pushState({ path: urlWithoutQuery }, "", urlWithQuery);
    }
};

export function createQueryMirrorPlugin() {
    return {
        getSources({ query }) {
            return [
                {
                    sourceId: 'queryMirrorPlugin',
                    getItems() {
                        return [{ query, id: 'query' }];
                    },
                    templates: {
                        header() {
                            let queryMirror = document.querySelector(`[data-autocomplete-source-id*="queryMirrorPlugin"]`);
                            if (query === "" || !query) {
                                if (queryMirror) {
                                    queryMirror.style.display = "none"
                                }
                                return null;
                            }

                            if (queryMirror) {
                                queryMirror.style.display = ""
                            }
                            return (
                                <section className="search-bar-popular">
                                    <p className="search-bar-popular__title">{i18n.global.t("algoliaSearch.queryMirrorTitle")}:</p>
                                </section>
                            );
                        },
                        item() {
                            const initialQuery = new URL(window.location).searchParams.get('query');
                            let queryMirrorPluginValue = document.getElementById('queryMirrorPlugin');
                            if (queryMirrorPluginValue) {
                                queryMirrorPluginValue.addEventListener("click", (event) => {
                                    EventBus.$emit("query-mirror-plugin-submit");
                                    EventBus.$emit("search-input-hit", event.target.innerText);

                                    pushHistory(event.target.innerText);
                                })
                                queryMirrorPluginValue.addEventListener("keyup", (event) => {
                                    if (event.key === "Enter") {
                                        EventBus.$emit("query-mirror-plugin-submit");
                                        EventBus.$emit("search-input-hit", event.target.innerText);

                                        pushHistory(event.target.innerText);
                                    }
                                })
                                if (!query && initialQuery) {
                                    queryMirrorPluginValue.innerText = initialQuery;
                                } else {
                                    queryMirrorPluginValue.innerText = query;
                                }
                            }

                            return (
                                <div className="search-bar-category__item">
                                    <p id="queryMirrorPlugin"></p>
                                </div>
                            );
                        },
                        noResults() {
                            return null;
                        },
                    },
                },
            ];
        },
    };
}
